import { usePersonalLineup } from './usePersonalLineup';

/**
 * Wrapper over usePersonalLineup in order to hide implementation details
 * and give ability to refresh pcl on render. Must be used in conjuction with useChannels
 */
export function usePersonalLineupPublic() {
  return usePersonalLineup({ staleTime: 0 });
}
